import { VALIDATION_RULES_REQUIRED } from '../../Template builder/const/templates';



const isFieldRequired = (validationRules = []) => {
  return Boolean(validationRules.find((rule) => rule?.rule === VALIDATION_RULES_REQUIRED));
};

export default isFieldRequired;
